import { render } from "./DialogBox.vue?vue&type=template&id=6806dfd6"
import script from "./DialogBox.vue?vue&type=script&lang=js"
export * from "./DialogBox.vue?vue&type=script&lang=js"

import "./DialogBox.vue?vue&type=style&index=0&id=6806dfd6&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__